"use client";

import dynamic from "next/dynamic";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { NotificationProvider } from "@/contexts/NotificationContext";
import { ThemeProvider } from "@/lib/theme";

const FCMProvider = dynamic(
  () => import("./FCMProvider").then((m) => ({ default: m.FCMProvider })),
  { ssr: false }
);

const ToasterWithCloseButton = dynamic(
  () => import("./ToasterWithCloseButton").then((m) => ({ default: m.ToasterWithCloseButton })),
  { ssr: false }
);

interface ProvidersProps {
  children: React.ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <NotificationProvider>
          <FCMProvider>
            {children}
            <ToasterWithCloseButton />
          </FCMProvider>
        </NotificationProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
